import React from 'react';
import PropTypes from 'prop-types';

import InternalLink from './InternalLink';

const SeoLandingLinks = ({ links }) => (
  <div>
    {links.map(({ anchorText, url }, index) => (
      <InternalLink
        key={anchorText}
        text={anchorText}
        url={url}
        hasComma={index + 1 < links.length}
      />
    ))}
  </div>
);

SeoLandingLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      anchorText: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  )
};
SeoLandingLinks.defaultProps = {
  links: []
};

export default SeoLandingLinks;
